import { TypographyBase, GTypographyLinkBase } from './variants';

import type { ITypography } from './variants/types';

/**
 * The HTML tag is set using the "forwardedAs" prop on the parent component.
 * @source https://styled-components.com/docs/api#forwardedas-prop
 */

const Typography = ({ to = '', tabIndex = 0, openInNewTab = false,  ...props }: ITypography) => {
  if (Boolean(to)) {
    return  <GTypographyLinkBase to={to} target={openInNewTab ? '_blank' : '_self'}  tabIndex={tabIndex} {...props} />;
  }
  return <TypographyBase {...props} />;
};

export default Typography;
